import { colors } from '&assets/constants/colors';
import { device } from '&assets/constants/responsiveness';
import styled from 'styled-components';

export const FooterWrapper = styled.div`
	display: flex;
	background-color: #efeff2;
	.footer-content {
		padding: 20px 0px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		.footer-logo {
			height: 30px;
		}
		.footer-middleText {
			color: #a1a5a7;

			letter-spacing: -0.03em;
			font-weight: 400;
			font-size: 0.875rem;
			line-height: 1.25rem;
		}
		.socials {
			display: flex;
			flex-direction: row;
			box-sizing: border-box;

			.box {
				display: flex;
				justify-content: center;
				align-items: center;
				width: 2.75rem;
				height: 2.75rem;
				margin: 0 2px;
			}
			.facebook {
				background-color: rgb(222, 226, 235);
			}
			.twitter {
				background-color: rgb(215, 215, 217);
			}
			.instagram {
				background-color: rgb(235, 220, 230);
			}
			.youtube {
				background-color: rgb(241, 215, 217);
			}
			.snapchat {
				background-color: rgb(231, 230, 217);
			}
		}
	}
	@media ${device.tablet} {
		.footer-content {
			flex-direction: column;
			justify-content: center;
			align-items: center;
			.socials {
				margin-top: 20px;
			}
		}
	}

	@media ${device.mobile} {
		.footer-content {
			flex-direction: column;
			justify-content: center;
			align-items: center;
			.socials {
				margin-top: 20px;
			}
		}
	}
`;
